"use client";

import {
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
} from "@oreme/ui";
import { useLocale, useTranslations } from "next-intl";
import React, { type ReactElement } from "react";
import type { Locale } from "@/i18n/config";
import { setUserLocale } from "@/i18n/locale";

function GlobalLocaleSwitcher(): ReactElement {
  const t = useTranslations("global.LocaleSwitcher");
  const locale = useLocale();

  const handleChange = async (value: string): Promise<void> => {
    await setUserLocale(value as Locale);
  };

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>{t("label")}</DropdownMenuSubTrigger>
      <DropdownMenuPortal>
        <DropdownMenuSubContent>
          <DropdownMenuRadioGroup
            onValueChange={(value) => void handleChange(value)}
            value={locale}
          >
            <DropdownMenuRadioItem value="fr">{t("fr")}</DropdownMenuRadioItem>
            <DropdownMenuRadioItem value="en">{t("en")}</DropdownMenuRadioItem>
          </DropdownMenuRadioGroup>
        </DropdownMenuSubContent>
      </DropdownMenuPortal>
    </DropdownMenuSub>
  );
}

export { GlobalLocaleSwitcher };
